import { jsx } from 'react/jsx-runtime';
import { BaseModalFloat } from '../BaseModalFloat/index.js';
import { CellModalButton } from '../CellModalButton/index.js';

const ModalFloatOneButton = ({
  buttonText,
  'data-test': testId,
  children,
  hasPrimaryButton,
  headingText,
  iconButtonCloseOnClick,
  isOpen,
  // react-modal prop
  isShort,
  onAfterClose,
  // react-modal prop
  onAfterOpen,
  // react-modal prop
  oneButtonOnClick,
  onRequestClose,
  // react-modal prop
  rootNodeId
}) => jsx(BaseModalFloat, Object.assign({
  "data-test": testId,
  headingText: headingText,
  iconButtonCloseOnClick: iconButtonCloseOnClick,
  isOpen: isOpen,
  isShort: isShort,
  onAfterClose: onAfterClose,
  onAfterOpen: onAfterOpen,
  onRequestClose: onRequestClose,
  renderCellButton: jsx(CellModalButton, {
    buttonText: buttonText,
    "data-test": "modalOneButton",
    hasPrimaryButton: hasPrimaryButton,
    onClick: oneButtonOnClick
  }, void 0),
  rootNodeId: rootNodeId
}, {
  children: children
}), void 0);

ModalFloatOneButton.displayName = 'ModalFloatOneButton';

export { ModalFloatOneButton };
